import { ChangeDetectionStrategy, Component, EventEmitter, Input, NgZone, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-dialog-header',
  templateUrl: './dialog-header.component.html',
  styleUrls: ['./dialog-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogHeaderComponent implements OnInit {

  @Input() public canClose: boolean = true;
  @Input() public header: string = '';
  @Input() public subtitle?: string | null = null;

  @Output() public backClick = new EventEmitter<void>();

  constructor(
    private ngZone: NgZone,
  ) { }

  public ngOnInit(): void {
  }

  public onClick(): void {
    this.ngZone.run(() => {
      this.backClick.emit();
    });
  }
}
